import { Recommendation } from 'shared/api/insights';
import { dateService } from 'shared/lib/date';

export const walkthroughRecommendation: Recommendation = {
  id: 'walkthroughRecommendation',
  app_product_names: ['Static'],
  type: 'recommendation',
  description: 'fake-description',
  start_relevant_date: 0,
  created_date: 0,
  content: {
    productNames: { 'fake-id': 'Amplify' },
    grade: '',
    message: 'Welcome to your Recommendations section!',
    actionType: 'Go',
    link: '',
    startDate: 0,
    image: '',
  },
} as Recommendation;

export const isRecommendationNew = (startRelevantDate?: number) => {
  if (!startRelevantDate) {
    return false;
  }

  const now = new Date().getTime();
  // Check if the recommendation initial appear date is not older than two days
  if (dateService.getDaysDifference(now, startRelevantDate) < 2) {
    return true;
  }
};
